/**
 * Animations pour le widget Ringado
 * Animations améliorées pour un design moderne comme la landing page
 */
export const ANIMATIONS_STYLES = `
  /* Animations */
  @keyframes ringado-wave-auto {
    0%, 70%, 100% { 
      transform: rotate(0deg) scale(1); 
    }
    10%, 30% { 
      transform: rotate(14deg) scale(1.02); 
    }
    20% { 
      transform: rotate(-8deg) scale(1.01); 
    }
    40% { 
      transform: rotate(14deg) scale(1.02); 
    }
    50% { 
      transform: rotate(-8deg) scale(1.01); 
    }
  }

  @keyframes ringado-wave-on-hover {
    0%, 100% { 
      transform: rotate(0deg) scale(1.1); 
    }
    25% { 
      transform: rotate(20deg) scale(1.15); 
    }
    75% { 
      transform: rotate(-10deg) scale(1.12); 
    }
  }

  @keyframes ringado-slide-up {
    0% {
      opacity: 0;
      transform: translateY(30px) scale(0.9);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes ringado-slide-down {
    0% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
    100% {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
  }

  @keyframes ringado-typing {
    0%, 60%, 100% { 
      transform: translateY(0); 
      opacity: 0.4; 
    }
    30% { 
      transform: translateY(-3px); 
      opacity: 1; 
    }
  }

  @keyframes pulse {
    0%, 100% { 
      opacity: 1; 
      transform: scale(1); 
    }
    50% { 
      opacity: 0.7; 
      transform: scale(1.05); 
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideInFromBottom {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes breathe {
    0%, 100% { 
      transform: scale(1); 
      filter: blur(12px);
    }
    50% { 
      transform: scale(1.1); 
      filter: blur(14px);
    }
  }

  /* Application des animations */
  .ringado-message {
    animation: fadeInUp 0.3s ease-out;
  }

  .ringado-chat-container {
    animation: slideInFromBottom 0.4s ease-out;
  }

  .ringado-chat-button::before {
    animation: breathe 4s ease-in-out infinite;
  }
`;
